<template>
  <v-app-bar
    dark
    dense
    :app="!isInDrawer"
    :flat="isInDrawer"
    :clipped-left="!$vuetify.rtl"
    :clipped-right="$vuetify.rtl"
    color="#343A40"
  >
    <v-app-bar-nav-icon
      @click.stop="$emit('toggle-drawer')"
      v-if="$vuetify.breakpoint.mdAndDown"
    ></v-app-bar-nav-icon>
    <v-toolbar-title :class="{ 'pl-2': $vuetify.breakpoint.mdAndDown }">
      <router-link to="/" class="d-flex align-center no-underline">
        <v-img
          src="@/assets/hiil-logo-dark-bg.png"
          height="40"
          width="66"
          contain
          position="left center"
        ></v-img>
        <div class="white--text font-weight-bold text-uppercase mx-4">
          {{ $t("interface.navTitle") }}
        </div>
      </router-link>
    </v-toolbar-title>
    <v-spacer></v-spacer>
    <TheLanguageSwitcher v-if="!isInDrawer" />
  </v-app-bar>
</template>

<script>
import TheLanguageSwitcher from "@/components/TheLanguageSwitcher.vue";
export default {
  props: {
    drawer: {
      type: Boolean
    },
    isInDrawer: {
      type: Boolean,
      default: false
    }
  },
  components: {
    TheLanguageSwitcher
  }
};
</script>

<style scoped>
.no-underline {
  text-decoration: none;
}
</style>